import ApiService from '@/services/core/api.service'

const ImportDataService = {
  async post (payload) {
    return ApiService.post('user/raw-data/import-from-excel', payload)
  }
}

export default ImportDataService
